import { zergApi } from "@/service/zerg";

class BasicsSettingsService {
    BASE_URL = "setting/general/basics";

    async getDefaultCountry(params) {
        const url = `${this.BASE_URL}/get-default-country`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default new BasicsSettingsService();